/**
 * Triggers a file download without navigating the page.
 * Creates a temporary anchor element to initiate the download.
 */
export const triggerDownload = (url: string, filename?: string): void => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "download";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



